export default [
    'adpPortal',
    'hrAlliance',
    'bambooHr',
    'ceridian',
    'dailyPay',
    'gusto',
    'greenshades',
    'insperity',
    'justworks',
    'netchex',
    'paychex',
    'paycom',
    'paycor',
    'paylocity',
    'proliant',
    'heartland',
    'rippling',
    'toast',
    'trinet',
    'ukgPro',
    'squareTeam',
    'cfmpw',
    'viventium',
    'genericManualInstructions',
    'zenefits',
    'ukgReady',
];
